import {
    NavigateFunction,
    NavigateOptions,
    To,
    Location,
} from 'react-router-dom'

let navigateFunction: NavigateFunction | null = null
let location: Location | null = null

export const setNavigateFunction = (fn: NavigateFunction | null): void => {
    navigateFunction = fn
}

export function navigate(to: To, options?: NavigateOptions): void {
    if (navigateFunction) {
        navigateFunction(to, options)
    } else {
        console.error('Navigate function not initialized.')
    }
}

export const setLocation = (loc: Location): void => {
    location = loc
}

export function getLocation(): Location | null {
    return location
}
